import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { domainSkillApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { DomainSkillFilters, DomainSkillFormData } from '../types/domain-skill';

export function useDomainSkills(filters?: DomainSkillFilters) {
  return useQuery({
    queryKey: queryKeys.domainSkills.list(filters),
    queryFn: () => domainSkillApi.listSkills(filters),
  });
}

export function useUpdateDomainSkill() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: DomainSkillFormData }) =>
      domainSkillApi.updateSkill(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.domainSkills.lists() }),
  });
}
